export default __webpack_public_path__ + "e9076a99a92cd74443e2e50b94588727.svg";